import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { generateUUId } from "./utils";
var TIMEOUT = 12 * 60 * 60 * 1000; // 12 hours

export var Session = /*#__PURE__*/function () {
  function Session() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Session);
    var timeout = options.timeout;
    this.startTime = 0;
    this.sessionid = 0;
    this.timeout = timeout || TIMEOUT;
    this.duration = 0;
  }
  _createClass(Session, [{
    key: "createSession",
    value: function createSession() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var sessionid = options.sessionid,
        startTime = options.startTime;
      this.sessionid = sessionid || generateUUId();
      this.startTime = startTime || Date.now();
      this.duration = 0;
      return this;
    }
  }, {
    key: "updateSession",
    value: function updateSession() {
      this.duration = Date.now() - this.startTime;
      var isTimeout = this.duration > this.timeout;
      if (isTimeout) {
        console.log('session timeout', this.duration);
        this.sessionid = generateUUId();
        this.duration = 0;
        this.startTime = Date.now();
      }
      return this;
    }
  }]);
  return Session;
}();
export var sessionInstance = new Session();